import { render, staticRenderFns } from "./App.vue?vue&type=template&id=f8b45aa8&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=f8b45aa8&prod&scoped=true&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&id=f8b45aa8&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b45aa8",
  null
  
)

export default component.exports